
import React from 'react'
import Button from './Button'
import Box from './Box'

/**
 * Tabs component.
 */

export default function Tabs({ labels, content, selected = 0, onSelect, ...props }) {
  return <Box className="Tabs">
    <Box className="labels">
      {labels.map((label, index) => {
        return <Tab
          key={label}
          selected={selected == index}
          onClick={e => onSelect({ index, label })}
        >
          {label}
        </Tab>
      })}
    </Box>
    <Box className="content" {...props}>
      {content({ selected })}
    </Box>
  </Box>
}

/**
 * Tab component.
 */

function Tab({ selected, children, ...props }) {
  return <Box className="label">
    <Button theme="minimal" hover={selected} {...props}>{children}</Button>
  </Box>
}
